import { PremiumReceivablesTransactionRecord } from "entities/UIModel/PremiumReceivablesTransactionRecord";

// The grid row mirrors the API entity field-for-field, so building one by hand
// (the Add modal, the Ledger Report's sample rows) would mean spelling out
// ~45 properties. This factory supplies the null baseline; callers spread it
// and override only what they actually have.
export const emptyPremiumReceivableRecord = (
  uniqueIdentifier: string
): PremiumReceivablesTransactionRecord => ({
  uniqueIdentifier,

  IdentityKey: 0,
  PremiumReceivableID: 0,
  PolicyHistoryID: null,

  UnderwriterTypeCode: null,
  UnderwriterTypeName: null,
  AgentID: null,
  AccountDate: null,
  AccountingPeriod: null,
  AccountingYear: null,
  AccountingMonth: null,

  TransactionDate: null,
  TransactionYear: null,
  TransactionMonth: null,
  TransactionDay: null,

  PolicyNumber: null,
  StateAbbr: null,

  PolicyDate: null,
  PolicyYear: null,
  PolicyMonth: null,
  PolicyYearMonth: null,

  PremiumReceivableTypeCode: null,
  PremiumReceivableTypeName: null,
  IsAccrual: null,

  PolicyCount: null,
  SIPolicyCount: null,

  LiabilityAmount: null,
  SILiabilityAmount: null,
  ActualFee: null,
  ActualPremiumTax: null,
  ActualRiskRate: null,
  ActualRemittance: null,
  RemitSplitPct: null,

  CoveringFromDate: null,
  CoveringUpToDate: null,
  ReceivedDate: null,

  ClosedDate: null,

  IsExtractedForUDB: null,
  IsError: null,
  LastModifiedDate: null,

  Comments: null,
  PremRecSeqNumber: null,

  OriginationSource: null,
  OriginationUser: null,

  IntegrationKey: null,

  RowsPerPage: null,
  CurrentRow: null,
  TotalRows: null,
  CurrentPage: null,
  TotalPages: null,

  TotalPolicyCount: null,
  TotalSIPolicyCount: null,
  TotalLiabilityAmount: null,
  TotalSILiabilityAmount: null,
  TotalActualFee: null,
  TotalActualRiskRate: null,
  TotalActualRemittance: null,
});
